import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

/*
 * Should eventually look like this:
 * {
 *   columnVisibility: [
 *     {
 *       pageName: 'leadsPage',
 *       columns: [
 *         {columnId: 'leadTemperature', visible: true},
 *         {columnId: 'message', visible: false},
 *       ],
 *     },
 *     {
 *       pageName: 'prospectsPage',
 *       columns: [
 *         {columnId: 'phonne', visible: true},
 *         {columnId: 'temp', visible: false},
 *         {columnId: 'facility', visible: false},
 *         {columnId: 'salesStage', visible: true},
 *         ...
 *       ],
 *     },
 *   ],
 *   dropdownSelectionDefaults: [
 *     {
 *       pageCode: 'newProspectPage',
 *       defaults: [
 *         {
 *           ddName: 'Communication Type',
 *           defaultValue: 'Phone Call',
 *         },
 *         {
 *           ddName: 'Referral Type',
 *           defaultValue: 'Unknown',
 *         },
 *       ],
 *     },
 *     {
 *       pageCode: 'convertLeadToProspectForm',
 *       defaults: [
 *         {
 *           ddName: 'Communication Type',
 *           defaultValue: 'Web Form',
 *         },
 *         {
 *           ddName: 'Referral Type',
 *           defaultValue: 'Word of Mouth',
 *         },
 *       ],
 *     },
 *   ],
 *   otherSetting1: {...},
 *   otherSetting2: {...},
 *   ...
 * }
 */

export const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState: initialState,
  reducers: {
    clearUserSettings: () => {
      return initialState;
    },

    setUserSettings: (state, action) => {
      return action.payload;
    },

    setUserSetting: (state, action) => {
      const { settingName, settingStructure } = action.payload;
      return { ...state, [settingName]: settingStructure };
    },
  },
});

export const { clearUserSettings, setUserSettings, setUserSetting } = userSettingsSlice.actions;

export default userSettingsSlice.reducer;
